import { useLocation } from 'react-router';

import { RootErrorFallback } from 'src/components/v2/RootErrorBoundary/RootErrorFallback';
import { InstrumentationErrorBoundary } from 'src/instrumentation/InstrumentationErrorBoundary';
import type { ChildrenOnlyProps } from 'src/types/components.types';

export function RootErrorBoundary(props: ChildrenOnlyProps) {
  const location = useLocation();

  return (
    <InstrumentationErrorBoundary
      resetKey={location.pathname}
      fallback={({ error }) => <RootErrorFallback error={error as Error} />}
      boundaryId='root'
    >
      {props.children}
    </InstrumentationErrorBoundary>
  );
}
